var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"팀 리스트 보기"}},[_c('TeamList')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"팀 추가"}},[_c('CreateTeam')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7e56436","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teams.vue
// module id = null
// module chunks = 